<template>
  <van-overlay z-index="10" :show="show" class-name="modal-overlay flex-center">
    <div class="modal">
      <div class="modal-title">{{ title }}</div>
      <div class="modal-content">{{ content }}</div>
      <div class="flex-center modal-actions">
        <van-button @click="handleCancel" round size="small" class="btn btn-cancel">
          {{ cancelText }}
        </van-button>
        <van-button @click="handleConfirm" round size="small" class="btn btn-confirm">
          Confirm
        </van-button>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: "NvConfirm",
  props: {
    title: {
      type: String,
      default: "Confirm"
    },
    show: {
      type: Boolean
    },
    content: {
      type: String,
      default: "Are you sure?"
    },
    cancelText: {
      type: String,
      default: "Cancel"
    }
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    handleConfirm() {
      this.$emit("confirm");
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  flex-direction: column;
  .modal {
    background: white;
    padding: 24px;
    width: 60%;
    border-radius: 10px;
    margin: auto 48px;
    text-align: center;
    &-title {
      font-weight: 500;
      font-size: $fs-l;
    }
    &-content {
      color: $fc-grey;
      font-size: $fs-s;
      padding: 10px;
    }
    &-actions {
      justify-content: space-between;
      padding-top: 10px;
      .btn {
        flex: 1;
      }
      .btn-cancel {
        border: 1px solid $color-main;
        color: $color-main;
      }
      .btn-confirm {
        margin-left: 16px;
        background: linear-gradient(135deg, $bg-l-start, $bg-l-end);
        border: none;
        color: white;
      }
    }
  }
}
</style>
